import { LegalLayout } from "@/components/LegalLayout";

const H2 = ({ children }) => (
  <h2 className="text-xl sm:text-2xl font-semibold tracking-tight text-white mt-4">
    {children}
  </h2>
);

const P = ({ children }) => (
  <p className="text-base text-slate-400 leading-relaxed">{children}</p>
);

const UL = ({ items }) => (
  <ul className="flex flex-col gap-2 pl-1">
    {items.map((item, i) => (
      <li key={i} className="flex items-start gap-3 text-base text-slate-400 leading-relaxed">
        <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-[#00DC82]" />
        <span>{item}</span>
      </li>
    ))}
  </ul>
);

const Section = ({ children }) => (
  <section className="flex flex-col gap-4">{children}</section>
);

export default function Support() {
  return (
    <LegalLayout title="SUPPORT">
      <Section>
        <P>Last Updated: July 2026</P>
        <P>We're here to help.</P>
        <P>
          Whether you have a question, found a bug or have an idea that could improve
          MockTP, we'd love to hear from you.
        </P>
      </Section>

      <Section>
        <H2>Email Support</H2>
        <P>
          <a href="mailto:support@mocktp.app" className="text-[#00DC82] hover:underline">
            support@mocktp.app
          </a>
        </P>
      </Section>

      <Section>
        <H2>General Enquiries</H2>
        <P>Questions about:</P>
        <UL
          items={[
            "Using MockTP",
            "Public launch availability",
            "Feature requests",
            "Bug reports",
            "Account enquiries (future)",
            "Website issues",
          ]}
        />
      </Section>

      <Section>
        <H2>Response Time</H2>
        <P>We aim to respond to all enquiries as quickly as possible.</P>
        <P>
          During public-launch preparation, response times may vary, but every message is
          read by the MockTP team.
        </P>
      </Section>

      <Section>
        <H2>Reporting Bugs</H2>
        <P>If you discover a bug, please include:</P>
        <UL
          items={[
            "Device model",
            "Android or iPhone",
            "App version",
            "A short description of the problem",
            "Screenshots if available",
          ]}
        />
      </Section>

      <Section>
        <H2>Feature Suggestions</H2>
        <P>Many MockTP improvements come directly from instructor feedback.</P>
        <P>If there's something that would make your day easier, let us know.</P>
      </Section>

      <Section>
        <H2>Website</H2>
        <P>
          <a
            href="https://mocktp.app"
            className="text-[#00DC82] hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://mocktp.app
          </a>
        </P>
      </Section>

      <Section>
        <H2>Email</H2>
        <P>
          <a href="mailto:support@mocktp.app" className="text-[#00DC82] hover:underline">
            support@mocktp.app
          </a>
        </P>
      </Section>

      <Section>
        <H2>Final Statement</H2>
        <P>MockTP is built by instructors, for instructors.</P>
        <P>Your feedback helps shape every future release.</P>
      </Section>
    </LegalLayout>
  );
}
